import { getServices } from '~/db/services';

export const useActionShowDialogFriendsChallenge = () => {
  const profile = useProfileStore();

  const route = useRoute();

  const { onPlay, complete } = useAbstractAction(
    'actionShowDialogFriendsChallenge',
    true
  );

  const lastDialogFriendsChallengeOpened = useNomadStorage(
    'lastDialogFriendsChallengeOpened',
    ''
  );

  const { open, onComplete: onCompleteShowDialogFriendsChallenge } =
    useDialogFriendsChallenge();

  const { $db } = useNuxtApp();
  const { friendsService } = getServices($db);

  const completeAction = () => {
    lastDialogFriendsChallengeOpened.value = new Date().toISOString();
    complete(true);
  };

  onCompleteShowDialogFriendsChallenge(() => {
    completeAction();
  });

  const checkIfhasFriends = async () => {
    const count = await friendsService.count();
    return count > 0;
  };

  const lastShowDialogHasExpired = computed(() => {
    if (!lastDialogFriendsChallengeOpened.value) return true;
    const time =
      new Date().getTime() -
      new Date(lastDialogFriendsChallengeOpened.value).getTime();

    if (time > 1000 * 60 * 60 * 24 * 15) {
      return true;
    }
    return false;
  });

  onPlay(async () => {
    if (
      route.path.includes(Sections.MyFriends) ||
      !profile.featureFlags.friend ||
      !lastShowDialogHasExpired.value
    ) {
      return complete(true);
    }

    const hasFriends = await checkIfhasFriends();
    if (hasFriends) {
      return complete(true);
    }

    open();
  });
};
